import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { OrderDirection } from '../../Datatable/OrderDirection';
import CargoTypeModel from '../../CargoTypeSelector/models/CargoTypeModel';

interface cargoTypeInputState {
    input: CargoTypeModel,
    selectedIndex: number,
    selectedUserId: number,
    triggerRefreshInput: number,
    inputExpand: boolean,
    triggerRefreshTable: number,
    cargoTypesCache: CargoTypeModel[],
    cargoTypes: CargoTypeModel[],
    cargoGroups: string[],
    searchText: string,
    orderBy: string,
    orderDirection: OrderDirection
}

const initialState: cargoTypeInputState = {
    input: {
        id: 0,
        name: "",
        cargoGroupName: "",
    } as CargoTypeModel,
    selectedIndex: -1,
    selectedUserId: -1,
    triggerRefreshInput: 0,
    inputExpand: true,
    triggerRefreshTable: 0,
    cargoTypesCache: [],
    cargoTypes: [],
    cargoGroups: [],
    searchText: "",
    orderBy: "updatedDate",
    orderDirection: OrderDirection.Desc,
}

export const CargoTypeManagementSlice = createSlice({
    name: "CargoTypeManagement",
    initialState,
    reducers: {
        resetCargoTypeInput: (state) => {
            state.input = initialState.input;
        },
        setPortInput: (state, action: PayloadAction<CargoTypeModel>) => {
            state.input = action.payload;
        },
        setName: (state, action: PayloadAction<string>) => {
            state.input.name = action.payload;
        },
        setCargoGroupName: (state, action: PayloadAction<string | null>) => {
            state.input.cargoGroupName = action.payload;
        },
        setSelectedPortIndex: (state, action: PayloadAction<number>) => {
            state.selectedIndex = action.payload;
        },
        setSelectedPortId: (state, action: PayloadAction<number>) => {
            state.selectedUserId = action.payload;
        },
        setTriggerRefreshInput: (state, action: PayloadAction<number>) => {
            state.triggerRefreshInput = action.payload;
        },
        setInputExpand: (state, action: PayloadAction<boolean>) => {
            state.inputExpand = action.payload;
        },
        setTriggerRefreshTable: (state, action: PayloadAction<number>) => {
            state.triggerRefreshTable = action.payload;
        },
        setCargoTypesCache: (state, action: PayloadAction<CargoTypeModel[]>) => {
            state.cargoTypesCache = action.payload;
        },
        setCargoTypes: (state, action: PayloadAction<CargoTypeModel[]>) => {
            state.cargoTypes = action.payload;
        },
        setCargoGroups: (state, action: PayloadAction<string[]>) => {
            state.cargoGroups = action.payload;
        },
        setCargoTypesearchText: (state, action: PayloadAction<string>) => {
            state.searchText = action.payload;
        },
        setOrderBy: (state, action: PayloadAction<string>) => {
            state.orderBy = action.payload;
        },
        setOrderDirection: (state, action: PayloadAction<OrderDirection>) => {
            state.orderDirection = action.payload;
        },
    }
});

export const cargoTypeManagerSelector = createSelector(
    (state: RootState) => state.cargoTypeManagement,
    (data) => data
);

export const {
    resetCargoTypeInput,
    setPortInput,
    setName,
    setCargoGroupName,
    setSelectedPortIndex,
    setSelectedPortId,
    setInputExpand,
    setTriggerRefreshTable,
    setCargoTypesCache,
    setCargoTypes,
    setCargoGroups,
    setCargoTypesearchText,
    setOrderBy,
    setOrderDirection
} = CargoTypeManagementSlice.actions;

export default CargoTypeManagementSlice.reducer;